import styled, { css } from 'styled-components'
import { Modal } from 'react-bootstrap'

export const ModalBody = styled(Modal.Body)`
  border: 1px solid;
  margin: 1rem;
  font-size: ${({ theme }) => theme.sizes.small};

  ${({ variant }) => {
    const colorSet = { info: 'primary', danger: 'danger', warning: 'alert' }[variant]
    return css`
      background-color: ${({ theme }) => theme.palette[colorSet][4]};
      border-color: ${({ theme }) => theme.palette[colorSet][3]};
    `
  }}
`

export const ModalHeader = styled(Modal.Header)`
  border: 0;
  padding-bottom: 0;

  .modal-title {
    font-size: ${({ theme }) => theme.sizes.normal};
  }
`
